<template>
  <div
    class="productSort"
    style="padding: 72px 12px 0; color: #000; background: #f5f5f8"
  >
    <div class="investment-plan-entry" @click="$router.push('/knowledge?tab=risk')">
      <div class="plan-entry-icon">
        <span></span>
        <i></i>
        <b></b>
      </div>
      <div class="plan-entry-copy">
        <small>DIVIDEND PRODUCTS</small>
        <h3>定返分红专区</h3>
        <p>按日返息 · 到期返本 · 到期返本返息</p>
      </div>
      <button>了解规则 ›</button>
    </div>

    <div
      v-if="categoryLoading"
      class="product-list-loading"
      aria-label="产品数据加载中"
    >
      <div v-for="item in 3" :key="item" class="product-loading-card">
        <span class="product-loading-line product-loading-title"></span>
        <span class="product-loading-line product-loading-meta"></span>
        <span class="product-loading-line product-loading-main"></span>
      </div>
    </div>

    <div v-else-if="category.length === 0" class="product-list-empty">
      <p>产品数据加载失败，请稍后重试</p>
      <button type="button" @click="loadCategories">重新加载</button>
    </div>

    <van-tabs
      v-else
      swipeable
      animated
      style="margin-top: 12px"
    >
      <van-tab
        v-for="(items, index) in category"
        :key="index"
        :title="items.name"
      >
        <div class="productSort_con">
          <div class="productSort_con_list">
            <div style="padding-top: 0px">
              <div
                class="productSort_block"
                style="
                  padding-top: 7px;
                  padding-left: 10px;
                  padding-right: 10px;
                  padding-bottom: 10px;
                "
                v-for="(item, index) in items.list"
                :key="index"
                @click="viewDetails(item)"
              >
                <div
                  style="
                    font-size: 15px;
                    font-weight: 500;
                    color: #333;
                    padding: 0 0px;
                    margin-top: 5px;
                    display: flex;
                    align-items: center;
                  "
                >
                  <span class="product-title-icon" aria-hidden="true"></span>
                  <div class="line-clamp1">
                    {{ item.title }}
                  </div>
                  <span class="product-type-badge">
                    {{ Number(item.project_type) === 2 ? "研发专区" : "分红型" }}
                  </span>
                  <p
                    class="productSort_block_left_dm"
                    :style="{
                      border:
                        item.additional == 1
                          ? '1px solid #FF2500'
                          : '0px solid #FF2500'
                    }"
                    style="
                      border: 1px solid #ff2500;
                      color: #ff2500;
                      padding: 1px 5px;
                      border-radius: 2px;
                      margin-left: 10px;
                      font-size: 10px;
                      border-radius: 3px;
                    "
                  >
                    {{ item.additional == 1 ? $t("m.shouyiguo") : "" }}
                  </p>
                  <template v-if="item.clock == 1">
                    <img
                      src="../../assets/images/licai/naozhong.png"
                      style="width: 25px; height: 25px; margin-left: 15px"
                      alt=""
                    />
                    <van-count-down
                      :time="item.end"
                      format="DD 天 HH 时 mm 分 ss 秒"
                    />
                  </template>
                  <img
                    v-if="item.additional == 1"
                    src="../../assets/images/licai/shouyi.png"
                    style="width: 25px; height: 25px; margin-left: 15px"
                    alt=""
                  />
                </div>
                <div>
                  <span class="zzsy" v-show="Number(item.added) > 0"
                    >增值收益</span
                  >
                </div>
                <div class="recommendation-rating" aria-label="推荐指数五星">
                  <span class="recommendation-label">推荐指数：</span>
                  <span class="recommendation-stars" aria-hidden="true">
                    <i v-for="star in 5" :key="star" :style="{ '--star-delay': `${(star - 1) * 0.24}s` }">★</i>
                  </span>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                  "
                ></div>
                <div class="product-card-main">
                  <!--平均收益-->
                  <div class="product-rate">
                    <div
                      style="
                        font-size: 24px;
                        color: #ff2500;
                        font-weight: bold;
                        line-height: 25px;
                    "
                  >
                      {{ formatPercent(item.rate)
                      }}<span style="font-size: 13px">%</span>
                    </div>
                    <div style="font-size: 13px; color: #666; margin-top: 3px">
                      {{ $t("m.rishouyi") }}
                    </div>
                  </div>
                  <!--投资-->
                  <div class="product-limits">
                    <div class="product-limit-item">
                      <span>起始投资</span>
                      <strong>
                        {{ formatAmount(item.min) }}
                        <small>USD</small>
                      </strong>
                      <div
                        v-if="investmentRestrictions(item).length"
                        class="investment-restrictions"
                        aria-label="投资限制"
                      >
                        <em
                          v-for="restriction in investmentRestrictions(item)"
                          :key="restriction"
                        >
                          {{ restriction }}
                        </em>
                      </div>
                    </div>
                    <div
                      class="product-gift-item"
                      v-if="Number(item.gift_fixed) > 0"
                    >
                      <span>红包金额</span>
                      <strong>{{ formatAmount(item.gift_fixed) }} USD</strong>
                    </div>
                  </div>
                  <div class="product-thumb">
                    <img
                      :src="productImage(item)"
                      :alt="item.title + ' 产品图片'"
                      loading="lazy"
                      @error="useProductFallback"
                    />
                  </div>
                  <div class="product-actions">
                    <div class="day-item" v-if="item.clock != 1">
                      {{ item.day }}{{ $t("m.day") }}
                    </div>
                    <button
                      type="button"
                      class="detail-btn"
                      @click.stop="viewDetails(item)"
                    >
                      详情
                    </button>
                    <button
                      type="button"
                      class="btn-tt"
                      :class="{ disabled: isProjectUnavailable(item) }"
                      @click.stop="details(item)"
                    >
                      {{ projectActionText(item) }}
                    </button>
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-top: 10px;
                    padding: 0 0px;
                  "
                >
                  <div
                    style="
                      flex: 1;
                      height: 6px;
                      background-color: #f3f0f6;
                      border-radius: 5px;
                      overflow: hidden;
                    "
                  >
                    <div
                      style="
                        background-color: var(--bg-color);
                        height: 100%;
                        border-radius: 6px;
                        transition: width 1.5s;
                      "
                      :style="{ width: item.schedule + '%' }"
                    ></div>
                  </div>
                  <span style="font-size: 12px; color: #666; margin-left: 10px"
                    >{{ formatPercent(item.schedule) }}%</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <div style="height: 60px"></div>
  </div>
</template>
<script>
import Socket from "@libs/chat";

var vm = null;
import $store from "../../store";
import { getCategory } from "@api/store";
import { appendCacheVersion } from "@utils/cacheVersion";
import "@assets/css/swiper.min.css";

const PRODUCT_CATEGORY_CONFIG = [
  { name: "新手专区", aliases: ["新手专区", "新手项目"] },
  { name: "热门专区", aliases: ["热门专区", "热门项目", "热门投资"] },
  { name: "高端领投", aliases: ["高端领投"] },
  { name: "活动专区", aliases: ["活动专区", "精选专区", "VIP专区"] }
];

function normalizeProductCategories(categories = []) {
  const source = Array.isArray(categories) ? categories : [];
  const usedIndexes = [];

  return PRODUCT_CATEGORY_CONFIG.map(config => {
    let categoryIndex = source.findIndex((item, index) => {
      return !usedIndexes.includes(index) && config.aliases.includes(item.name);
    });

    if (categoryIndex === -1) {
      categoryIndex = source.findIndex((item, index) => {
        return !usedIndexes.includes(index);
      });
    }

    if (categoryIndex === -1) {
      return null;
    }

    usedIndexes.push(categoryIndex);
    return Object.assign({}, source[categoryIndex], {
      name: config.name,
      desc: config.name
    });
  }).filter(Boolean);
}

export default {
  name: "GoodsClass",
  components: {},
  props: {},
  computed: {
    huilv: function() {
      return $store.state.app.huilv;
    }
  },
  watch: {
    huilv: "gaibian"
  },
  data: function() {
    return {
      socket: null,
      currentRate0: 30,
      currentRate1: 30,
      jinyin: {
        jin: 1.0004,
        type1: true,
        fudu1: "+0.0002",
        min1: "1.0000",
        max1: 1.0004,
        bfb1: "-0.0001%",
        yin: 6.35,
        type2: false,
        fudu2: -0.06,
        bfb2: "-0.07%",
        xin: 6.34,
        type3: true,
        fudu3: +0.03,
        bfb3: "+0.04%"
      },
      sj: true,
      gglist: [],
      shangsheng: require("@/assets/images/new/shangsheng.png"),
      xiajiang: require("@/assets/images/new/xiajiang.png"),
      swiperOption: {
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        pagination: {
          el: ".swiper-pagination"
        },
        on: {
          click: function() {
            const realIndex = this.realIndex;

            vm.dianjilb(realIndex);
          }
        }
      },
      image:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F015ef657bc11150000012e7eafa2e0.png%402o.png&refer=http%3A%2F%2Fimg.zcool.cn&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=jpeg?sec=1634556413&t=2fb650f58dfd37bf68e8ffd138c2dc73",
      fallbackProductImage: require("@/assets/images/asm-premium/advanced-packaging-fab.webp"),
      category: [],
      categoryLoading: true,
      categoryRequestId: 0,
      linshi: null,
      navActive: 0,
      search: "",
      remen: [],
      lock: false,
      tabbers: 0,
      // 商品选择类型
      selectList: [
        {
          id: 0,
          tit: "新手专区"
        },
        {
          id: 1,
          tit: "热门专区"
        },
        {
          id: 2,
          tit: "高端领投"
        },
        {
          id: 3,
          tit: "活动专区"
        }
      ],
      reRender: true,
      // 商品列表
      productList: [
        {
          id: 0,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        },
        {
          id: 1,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        },
        {
          id: 2,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        },
        {
          id: 3,
          url: "/h5/img/licai.379d174e.png",
          name: "东财新能源车",
          dn: "010805",
          ys: "21",
          hb: "0.81"
        }
      ]
    };
  },

  activated() {
    this.reRender = false;
    setTimeout(() => {
      this.reRender = true;
    }, 10);
    if (this.category.length > 0 && !this.categoryLoading) {
      this.loadCategories();
    }
  },
  mounted: function() {
    this.socket = new Socket();
    this.socket.vm(this);

    this.$on("onMessage", data => {
      this.jinyinIndex = 1;

      if (data.code) {
        if (data.code == "0" && data.data.length > 0) {
          if (data.data[0].usdCny) {
            let USD = data.data[0].usdCny;
            let cce = (USD * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            if (this.jinyin.xin <= USD) {
              this.jinyin.type3 = true;
            } else {
              this.jinyin.type3 = false;
            }
            this.jinyin.yin = cce;
            this.jinyin.xin = USD;
          }
        }
      }
      if (data.arg) {
        if (data.arg.channel == "tickers" && data.arg.instId == "USDT-USDK") {
          if (data.data.length > 0) {
            if (this.jinyin.jin <= data.data[0].last) {
              this.jinyin.type1 = true;
            } else {
              this.jinyin.type1 = false;
            }
            this.jinyin.jin = data.data[0].last; //最新价
            this.jinyin.max1 = data.data[0].high24h; //最高价
            this.jinyin.min1 = data.data[0].low24h; //最低价
            let kai = data.data[0].open24h; //开盘价
            let cha = (this.jinyin.jin - kai).toFixed(4);
            if (cha >= 0) {
              this.jinyin.fudu1 = "+" + cha;
              this.jinyin.bfb1 = "+" + (cha / kai).toFixed(4) + "%";
            } else {
              this.jinyin.fudu1 = cha;
              this.jinyin.bfb1 = (cha / kai).toFixed(4) + "%";
            }

            let cce = (this.jinyin.yin * this.jinyin.jin).toFixed(2);
            if (this.jinyin.yin <= cce) {
              this.jinyin.type2 = true;
            } else {
              this.jinyin.type2 = false;
            }
            this.jinyin.yin = cce;
          }
        }
      }

      let huilv = this.jinyin.jin * this.jinyin.yin;
      let ss = $store.state.app.huilv;
      if (huilv >= ss) {
        this.shangxia = true;
      } else {
        this.shangxia = false;
      }
      this.$store.commit("HUILV", huilv);
    });
    this.$on("socket_error", () => {
      // this.$dialog.error("连接失败");
    });
    this.$on("err_tip", data => {
      // this.$dialog.error(data.msg);
    });
    this.$on("socket_open", () => {
      // this.$dialog.error("连接成功");
    });

    this.loadCategories();
  },
  created() {
    vm = this;
  },
  methods: {
    loadCategories() {
      const requestId = ++this.categoryRequestId;
      this.categoryLoading = true;
      this.category = [];
      getCategory().then(res => {
        if (requestId !== this.categoryRequestId) {
          return;
        }
        let category = Array.isArray(res.data.data) ? res.data.data : [];
        console.log("-> category", category);
        category = category.map(item => {
          let dic = (item.list || []).map(v => {
            v.schedule = Number(v.schedule).toFixed(2);
            return v;
          });
          return Object.assign({}, item, { list: dic });
        });
        const displayCategory = normalizeProductCategories(category);
        this.category = JSON.parse(JSON.stringify(displayCategory));
        this.linshi = JSON.parse(JSON.stringify(displayCategory));
        this.categoryLoading = false;
      }).catch(() => {
        if (requestId !== this.categoryRequestId) {
          return;
        }
        this.category = [];
        this.linshi = [];
        this.categoryLoading = false;
      });
    },
    productImage(item) {
      const image = String((item && item.image) || "").trim();
      if (!image) {
        return this.fallbackProductImage;
      }
      const itemVersion = item.updated_at || item.update_time || item.id || 0;
      return appendCacheVersion(image, itemVersion);
    },
    useProductFallback(event) {
      const image = event && event.target;
      if (image && !image.dataset.fallbackApplied) {
        image.dataset.fallbackApplied = "1";
        image.src = this.fallbackProductImage;
      }
    },
    gaibian(val, olVal) {
      console.log("新：" + val);
      console.log("旧：" + olVal);
      // console.log(this)
      if (val > olVal) {
        this.fangfa(true);
      } else {
        this.fangfa(false);
      }
    },
    fangfa(e) {
      this.sj = e;
    },
    dianjilb(e) {
      this.$router.push({
        path: "/detail/" + this.remen[e].id
      });
    },
    isProjectFull(item) {
      if (!item) {
        return false;
      }
      return Number(item.status) == 2 || Number(item.schedule) >= 100;
    },
    isProjectNotStarted(item) {
      return item && Number(item.status) == 0;
    },
    isProjectUnavailable(item) {
      return this.isProjectNotStarted(item) || this.isProjectFull(item);
    },
    projectActionText(item) {
      if (this.isProjectNotStarted(item)) {
        return "未开启";
      }
      return this.isProjectFull(item) ? "已满仓" : "投资";
    },
    viewDetails(item) {
      if (!item || !item.id) {
        return;
      }
      this.$router.push({
        path: "/detail/" + item.id
      });
    },
    details: function(item) {
      if (this.isProjectNotStarted(item)) {
        this.$dialog.message("项目未开启");
        return;
      }
      if (this.isProjectFull(item)) {
        this.$dialog.message("项目已满仓");
        return;
      }
      this.$router.push({
        path: "/detail/" + item.id
      });
    },
    goTo() {
      this.$router.push({
        path: "/article"
      });
    },
    formatAmount(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value || "0.00";
      }
      return num.toFixed(2);
    },
    formatPercent(value) {
      const num = Number(value);
      if (Number.isNaN(num)) {
        return value || "0.00";
      }
      return num.toFixed(2);
    },
    investmentRestrictions(item) {
      if (!item) {
        return [];
      }

      const restrictions = [];
      const vip = Number(item.vip);
      const maxInvestments = Number(item.mcount);

      if (Number.isFinite(vip) && vip > 0) {
        restrictions.push(`限VIP${vip}及以上投`);
      }
      if (Number.isFinite(maxInvestments) && maxInvestments > 0) {
        restrictions.push(`限投${maxInvestments}次`);
      }

      return restrictions;
    },
    xiangqing: function() {
      this.$router.push({
        path: "/goods_evaluate/10"
      });
    },
    qiehuan: function(tabs) {
      this.tabbers = tabs;
    }
  }
};
</script>
<style scoped lang="less">
.investment-plan-entry {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 92px;
  margin-top: 0;
  padding: 15px;
  color: #fff;
  overflow: hidden;
  background: transparent;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.plan-entry-icon {
  position: relative;
  width: 48px;
  height: 48px;
  flex: 0 0 auto;
  margin-right: 12px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 14px;
}

.plan-entry-icon span,
.plan-entry-icon i,
.plan-entry-icon b {
  position: absolute;
  bottom: 11px;
  width: 5px;
  background: #9ed8ff;
  border-radius: 4px 4px 1px 1px;
}

.plan-entry-icon span {
  left: 10px;
  height: 11px;
}

.plan-entry-icon i {
  left: 21px;
  height: 19px;
}

.plan-entry-icon b {
  left: 32px;
  height: 27px;
  background: #ffdc8b;
}

.plan-entry-copy {
  min-width: 0;
}

.plan-entry-copy small {
  color: #9dd0fb;
  font-size: 8px;
  letter-spacing: 1px;
}

.plan-entry-copy h3 {
  margin: 4px 0;
  font-size: 17px;
}

.plan-entry-copy p {
  color: rgba(255, 255, 255, 0.66);
  font-size: 9px;
}

.investment-plan-entry > button {
  margin-left: auto;
  padding: 8px 10px;
  color: #fff;
  font-size: 9px;
  background: rgba(4, 39, 73, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.48);
  border-radius: 16px;
  box-shadow: 0 5px 14px rgba(1, 25, 49, 0.2);
}

.home_tit {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
}

.home_tit_top {
  height: 50px;
  padding: 0 15px;
  display: flex;
  align-items: center;
}

.home_swiper {
  width: 100%;
  height: 190px;
}

.home_swiper swiper-slide {
  width: 100%;
  height: 190px;
}

.home_swiper {
  height: 190px;
}

.banner_img {
  width: 100%;
  height: 190px;
}

.home_tit_left {
  width: 25%;
  display: flex;
  align-items: center;
}

.home_tit_left img {
  width: 23px;
  height: 23px;
}

.home_tit_left div {
  margin: 0 20px;
  color: #333;
  font-size: 16px;
}

.home_tit_middle {
  flex: 1;
  display: flex;
  align-items: center;
  padding: 8px 15px;
  margin: 0 0px;
  color: #333;
  font-weight: bold;
  font-size: 22px;
}

.home_tit_middle img {
  width: 15px;
  height: 15px;
  margin-left: 7px;
}

.home_tit_right {
  padding-right: 10px;
  width: 50%;
  display: flex;
  align-items: center;
  color: #333;
  flex-direction: row-reverse;

  font-size: 15px;
  font-weight: bold;
}

.home_tit_right img {
  width: 22px;
  height: 22px;
  margin-left: 7px;
}

.line-clamp1 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.productSort_block_left_xh {
  max-width: 220px;
  overflow: hidden; /*超出部分隐藏*/
  white-space: nowrap; /*禁止换行*/
  text-overflow: ellipsis; /*省略号*/
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 36px;
}

.productSort_block_left_dm {
  border: 0px solid #ffa68c;
  color: #ffa68c;
  padding: 2px 5px;
  border-radius: 2px;
  font-size: 11px;
}

/deep/ .van-circle__text {
  color: #666;
  font-size: 13px;
}

.productSort_block_last {
  padding: 0px 0px;
  align-items: center;
  display: flex;
}

.productSort_block_last_item:last-child {
  margin-left: 60px;
}

.productSort_block_left {
  display: flex;
  align-items: center;
  padding: 0 0px;
  margin-bottom: 6px;
  // justify-content: space-between;
}

.productSort_con_list {
  margin-top: 0px;
  // background-color: #fff;
  padding: 0 0px;

  overflow: scroll;
  border-radius: 10px;
}

.productSort_block {
  position: relative;
  isolation: isolate;
  overflow: hidden;
  width: 100%;
  background:
    radial-gradient(
      circle at 92% 8%,
      rgba(39, 145, 232, 0.11) 0,
      rgba(39, 145, 232, 0.04) 22%,
      transparent 43%
    ),
    linear-gradient(145deg, #ffffff 0%, #fcfdff 58%, #f5f9fd 100%);
  padding: 10px 5px;
  padding-bottom: 5px;
  margin-bottom: 10px;
  border: 1px solid rgba(91, 157, 213, 0.13);
  border-radius: 12px;
  box-shadow: 0 7px 20px rgba(30, 91, 149, 0.055);
}

.productSort_block::before {
  content: "";
  position: absolute;
  z-index: -1;
  right: -15px;
  bottom: -24px;
  width: 170px;
  height: 125px;
  pointer-events: none;
  opacity: 0.46;
  background:
    radial-gradient(circle at 20px 23px, rgba(42, 132, 207, 0.18) 0 2px, transparent 2.5px),
    radial-gradient(circle at 87px 51px, rgba(42, 132, 207, 0.14) 0 2px, transparent 2.5px),
    radial-gradient(circle at 137px 87px, rgba(42, 132, 207, 0.17) 0 2px, transparent 2.5px),
    linear-gradient(90deg, transparent 19px, rgba(42, 132, 207, 0.09) 20px 21px, transparent 22px)
      0 0 / 58px 100%,
    linear-gradient(0deg, transparent 22px, rgba(42, 132, 207, 0.08) 23px 24px, transparent 25px)
      0 0 / 100% 42px;
  transform: rotate(-8deg);
}

.productSort_block::after {
  content: "";
  position: absolute;
  z-index: -1;
  right: 79px;
  top: 50px;
  width: 50px;
  height: 50px;
  border: 1px solid rgba(31, 126, 207, 0.08);
  border-radius: 12px;
  box-shadow:
    0 0 0 7px rgba(31, 126, 207, 0.025),
    0 0 0 14px rgba(31, 126, 207, 0.018);
  transform: rotate(12deg);
}

.productSort_block:last-child {
  border-bottom: 0px solid #eee;
}

.productSort_block img {
  width: 100%;
  height: 86px;
}

.product-title-icon {
  position: relative;
  flex: 0 0 18px;
  width: 18px;
  height: 18px;
  margin-right: 6px;
  border-radius: 5px;
  background: linear-gradient(145deg, #e8f5ff, #d7ebfb);
  border: 1px solid rgba(39, 132, 208, 0.28);
  box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.7);
}

.product-title-icon::before {
  content: "";
  position: absolute;
  inset: 4px;
  border: 1px solid rgba(25, 112, 187, 0.56);
  border-radius: 2px;
  background:
    linear-gradient(90deg, transparent 44%, rgba(25, 112, 187, 0.25) 44% 56%, transparent 56%),
    linear-gradient(0deg, transparent 44%, rgba(25, 112, 187, 0.25) 44% 56%, transparent 56%);
}

.product-title-icon::after {
  content: "";
  position: absolute;
  left: 2px;
  right: 2px;
  top: -2px;
  height: 1px;
  border-top: 1px solid rgba(25, 112, 187, 0.35);
  border-bottom: 1px solid rgba(25, 112, 187, 0.35);
  box-shadow: 0 18px 0 rgba(25, 112, 187, 0.35);
}

.productSort_top {
  overflow-x: auto;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  padding: 0 6px;
  /* justify-content: space-between; */
}

.productSort {
  position: relative;
  isolation: isolate;
  background: #f5f5f8 !important;
}

.productSort::before {
  position: absolute;
  z-index: -2;
  top: 0;
  right: -12px;
  left: -12px;
  height: 178px;
  content: "";
  background:
    linear-gradient(180deg, rgba(3, 28, 55, 0.08), rgba(3, 28, 55, 0.28)),
    url("../../assets/images/asm-premium/robot-chip-product-hero-v2.jpg") center 37% / cover no-repeat;
}

.productSort::after {
  position: absolute;
  z-index: -1;
  top: 20px;
  left: 18px;
  width: 132px;
  height: 30px;
  content: "";
  opacity: 0.96;
  background: url("../../assets/images/asmpt_logo.svg") left center / contain no-repeat;
  filter: brightness(0) invert(1);
  pointer-events: none;
}

.productSort_top_block {
  flex-shrink: 0;

  display: inline-block;
  margin-right: 14px;
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 36px;
  text-align: center;
}

.jiangli_top {
  width: 100%;
  height: 50px;
  background-color: #ffffff;
}

.productSort_top_blocks {
  border-bottom: 2px solid #007aff;
  color: #007aff;
}

/deep/ .van-tabs__nav {
  background-color: #f5f5f8 !important;
  overflow: scroll;
}

/deep/ .van-tab {
  height: 20px;
  font-weight: 600;
  font-size: 13px;
  border-right: 1px solid #eee;
  flex: none;
  min-width: 20%;
  // margin-right: 10px;
}

.van-tab--active .van-tab:last-child {
  border-right: 0px solid #fff !important;
}

/deep/ .van-tab--active {
  color: #000;
  font-size: 14px;
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 0px;
  height: 50px;
  box-sizing: border-box;
}

/deep/ .van-tabs__wrap {
  height: 34px;
}

/deep/ .van-tabs__line {
  min-width: 15%;
  top: 28px;
  background: var(--bg-color);
}

/deep/ .swiper-pagination-bullet {
  border: 1px solid #ff3738;
  background: #fff;
}

/deep/ .swiper-pagination-bullet-active {
  // 这以下的代码是你需要的
  background: #ff3738;
  border: 0px solid #ff3738;
}

/deep/ .van-tabs__nav--line.van-tabs__nav--complete {
  padding-left: 0;
  padding-right: 0;
}

.day-item {
  display: flex;
  width: 100%;
  height: 24px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: #f44336;
  color: #fff;
  padding: 0 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  white-space: nowrap;
  border-radius: 10px;
}

.product-card-main {
  display: grid;
  grid-template-columns: 80px minmax(88px, 1fr) 94px 62px;
  gap: 6px;
  align-items: center;
  width: 100%;
  min-height: 96px;
  padding-top: 7px;
  border-radius: 6px;
  box-sizing: border-box;
}

.product-thumb {
  position: relative;
  width: 94px;
  height: 72px;
  overflow: hidden;
  background: #edf3f8;
  border: 1px solid rgba(50, 112, 168, 0.12);
  border-radius: 10px;
  box-shadow: 0 5px 14px rgba(34, 79, 119, 0.1);
}

.product-thumb::after {
  position: absolute;
  inset: 0;
  content: "";
  pointer-events: none;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.14), transparent 52%);
}

.productSort_block .product-thumb img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 390px) {
  .product-card-main {
    grid-template-columns: 72px minmax(84px, 1fr) 82px 58px;
    gap: 5px;
  }

  .product-thumb {
    width: 82px;
    height: 68px;
  }

  .product-actions,
  .product-actions button {
    width: 58px;
  }
}

@media (max-width: 350px) {
  .product-card-main {
    grid-template-columns: 64px minmax(72px, 1fr) 68px 52px;
    gap: 4px;
  }

  .product-thumb {
    width: 68px;
    height: 62px;
  }

  .product-actions,
  .product-actions button {
    width: 52px;
  }
}

.recommendation-rating {
  display: flex;
  align-items: center;
  height: 18px;
  margin: 5px 0 -2px 24px;
  line-height: 1;
}

.recommendation-label {
  color: #718096;
  font-size: 11px;
}

.recommendation-stars {
  display: inline-flex;
  gap: 2px;
  margin-left: 2px;
}

.recommendation-stars i {
  position: relative;
  color: #ffb21c;
  font-size: 13px;
  font-style: normal;
  filter: drop-shadow(0 1px 2px rgba(227, 145, 0, 0.25));
  transform-origin: center;
  animation: recommendation-star-glow 2.4s ease-in-out infinite;
  animation-delay: var(--star-delay);
}

@keyframes recommendation-star-glow {
  0%,
  68%,
  100% {
    color: #ffb21c;
    filter: drop-shadow(0 1px 2px rgba(227, 145, 0, 0.2));
    transform: scale(1);
  }
  78% {
    color: #ffe278;
    filter:
      drop-shadow(0 0 3px rgba(255, 192, 35, 0.8))
      drop-shadow(0 0 7px rgba(255, 209, 79, 0.55));
    transform: scale(1.16) rotate(-5deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .recommendation-stars i {
    animation: none;
  }
}

.product-rate {
  min-width: 0;
  text-align: left;
}

.product-limits {
  min-width: 0;
  overflow: hidden;
  padding: 5px 2px;
  color: #6f7d8c;
  background: transparent;
  border: 0;
  border-radius: 0;
  font-size: 11px;
  line-height: 1.25;
  white-space: normal;
}

.product-limit-item,
.product-gift-item {
  display: flex;
  min-width: 0;
  flex-direction: column;
  align-items: flex-start;
}

.product-limit-item span,
.product-gift-item span {
  color: #7b8997;
  font-size: 10px;
}

.product-limit-item strong {
  display: block;
  max-width: 100%;
  margin-top: 5px;
  overflow: hidden;
  color: #e64332;
  font-size: 13px;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-limit-item small {
  color: #e64332;
  font-size: 9px;
  font-weight: 600;
}

.investment-restrictions {
  display: flex;
  max-width: 100%;
  flex-wrap: wrap;
  gap: 3px;
  margin-top: 5px;
}

.investment-restrictions em {
  display: inline-block;
  max-width: 100%;
  padding: 2px 5px;
  overflow: hidden;
  color: #c73d32;
  font-size: 9px;
  font-style: normal;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
  background: rgba(255, 239, 236, 0.9);
  border: 1px solid rgba(221, 91, 74, 0.22);
  border-radius: 8px;
}

.product-gift-item {
  margin-top: 6px;
  padding-top: 5px;
  border-top: 1px solid rgba(74, 133, 183, 0.12);
}

.product-gift-item strong {
  margin-top: 3px;
  color: #d99a23;
  font-size: 10px;
  white-space: nowrap;
}

.btn-tt {
  width: 64px;
  background: #0372fb;
  color: #fff;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  border-radius: 16px;
  line-height: 25px;
  height: 31px;
  border: 0;
}
.btn-tt.disabled {
  background: #b8bcc6;
}

.product-actions {
  display: flex;
  flex: 0 0 64px;
  flex-direction: column;
  gap: 4px;
}

.product-actions button {
  cursor: pointer;
}

.detail-btn {
  width: 64px;
  height: 29px;
  padding: 0;
  color: #176fca;
  font-size: 13px;
  font-weight: 500;
  background: #f3f8ff;
  border: 1px solid #8dbfec;
  border-radius: 15px;
}

.zzsy {
  background: #fff4d5;
  color: #ff9800;
  padding: 3px 6px;
  font-size: 12px;
  font-weight: 400;
  border-radius: 4px;
  margin-right: 6px;
  border: 1px solid #ff9800;
}

.product-type-badge {
  flex: 0 0 auto;
  margin-left: 7px;
  padding: 2px 6px;
  color: #176fca;
  font-size: 10px;
  line-height: 1.3;
  background: #edf6ff;
  border: 1px solid #b9daf8;
  border-radius: 9px;
}

.product-list-loading {
  margin-top: 12px;
}

.product-loading-card {
  min-height: 142px;
  margin-bottom: 10px;
  padding: 16px 14px;
  background: #fff;
  border: 1px solid rgba(34, 84, 132, 0.08);
  border-radius: 9px;
}

.product-loading-line {
  display: block;
  height: 12px;
  margin-bottom: 14px;
  overflow: hidden;
  background: #edf1f5;
  border-radius: 6px;
  animation: product-list-pulse 1.15s ease-in-out infinite alternate;
}

.product-loading-title {
  width: 66%;
}

.product-loading-meta {
  width: 42%;
}

.product-loading-main {
  width: 88%;
  height: 48px;
  margin-top: 22px;
}

.product-list-empty {
  margin-top: 12px;
  padding: 36px 16px;
  color: #777;
  text-align: center;
  background: #fff;
  border-radius: 9px;
}

.product-list-empty button {
  margin-top: 12px;
  padding: 7px 20px;
  color: #fff;
  background: #176fca;
  border: 0;
  border-radius: 16px;
}

@keyframes product-list-pulse {
  from {
    opacity: 0.48;
  }
  to {
    opacity: 0.92;
  }
}
</style>

